import type { CommandHandler } from '../types';

export const sendSimpleOutboundCommandHandler: CommandHandler = async (_command, context) => {
  const clientId = Number(context.entityId ?? context.parentId);
  if (!Number.isInteger(clientId) || clientId <= 0) {
    return {
      success: false,
      error: 'Client ID is not available.',
    };
  }

  if (!context.openSendSimpleOutboundDialog) {
    return {
      success: false,
      error: 'Send email dialog is not available.',
    };
  }

  return context.openSendSimpleOutboundDialog(clientId);
};
